export const TRACKING_RECENT_JOBS = 'recent-jobs';
export const TRACKING_DASHBOARD_JOB_LIST = 'dashboard job list';
export const TRACKING_DASHBOARD_MAIN = 'dashboard main';
export const TRACKING_DASHBOARD_ARTICLE = 'dashboard article';
export const TRACKING_DASHBOARD_BALANCE_WIDGET = 'dashboard balance widget';
export const TRACKING_DASHBOARD_TS_WIDGET = 'dashboard ts widget';
export const TRACKING_HIRING_ADVICE = 'hiring-advice';
export const TRACKING_DASHBOARD_HERO = 'dashboard hero';
